import React, { useEffect, useRef } from 'react'

export default function Video({ link, title, anchor, passedDowntwo, bgcolor, sidebarOpen }) {
  const ref = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) passedDowntwo(bgcolor || '#f3f1ed') },
      { threshold: 0.3 }
    )
    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [bgcolor, passedDowntwo])

  return (
    <div id={anchor} ref={ref} style={{ width: '100%', textAlign: 'center' }}>
      <div className="proj">
        <div className="title">{title}</div>
        <iframe
          src={link}
          style={{
            display: 'block',
            margin: '0 auto',
            width: sidebarOpen ? '88%' : '94%',
            maxWidth: '1600px',
            aspectRatio: '16 / 9',
            height: 'auto',
            border: 'none',
            transition: 'width 0.35s cubic-bezier(0.4,0,0.2,1)',
          }}
          allowFullScreen
        />
      </div>
    </div>
  )
}
